<div *ngIf="needsAddressVerification" class="address-verification-banner" role="status">
  <span>We couldn't verify your address on the map. Until it's verified, we may not be able to send you jobs near you.</span>
  <a routerLink="/manageaccount" [queryParams]="{ tab: 'profile' }" fragment="address">Verify your address</a>
</div>
